const baseUrl           = `https://${window.location.hostname}/`;
const backUrl           = `${baseUrl}index.php`;

const config = {
    baseUrl,
    backUrl
};

export default config;